module.exports = __webpack_public_path__ + "img/main-page-image.15a8a543.png";